export default __webpack_public_path__ + "static/media/threshold.4d026f54.svg";